import { render, staticRenderFns } from "./StoryMedia.vue?vue&type=template&id=5192877b&scoped=true"
import script from "./StoryMedia.vue?vue&type=script&lang=ts"
export * from "./StoryMedia.vue?vue&type=script&lang=ts"
import style0 from "./StoryMedia.vue?vue&type=style&index=0&id=5192877b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5192877b",
  null
  
)

export default component.exports